


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { GoogleMapMarker } from "@/pitprojekt/types";

@Component({})
export default class GoogleMap extends Vue {
  @Prop(Array) markers!: Array<any>
  @Prop(String) zoom!: string;
  @Prop(String) height!: string;
  mapZoom: number = 10;
  mapHeight: string = '400';
  center: object = { lat: 53.5818, lng: 17.8694 };
  mapMarkers: Array<GoogleMapMarker> = [{'position': {lat: 53.5818, lng: 17.8694}}];

  @Watch('markers')
  onMarkers() {
    this.geolocate();
  }

  created() {
    if (this.zoom != undefined) this.mapZoom = Number(this.zoom);
    if (this.height != undefined) this.mapHeight = this.height;
  }


  geolocate() {
    if (this.markers.length > 0 && this.markers[0].position.lat != undefined ) {
      this.mapMarkers = this.markers;
      this.center = this.mapMarkers[0].position;
    }
  }
}
